<template>
    <tr v-if="store" @click.prevent="openSearch" class="transition duration-200 hover:bg-gray-100 cursor-pointer group">
        <td class="border-b pl-2 py-2 pr-1 sm:pr-2 text-center">
            <div v-if="store.image_url" class="store-avatar text-center mx-auto w-12 h-12">
                <img :src="store.image_url" :alt="store.name" class="block p-2 rounded-circle bg-white store-avatar-img mx-auto" class2="w-12 h-12" />
            </div>
        </td>
        <td class="border-b pl-2 pr-4 py-2 sm:pl-0">
            <div class="text-gray-700 font-semibold sm:whitespace-no-wrap group-hover:text-blue-600">
                {{ store.name }}
            </div>

            <div class="text-gray-600 text-xs group-hover:text-gray-800">
                {{ product.name }}
                <!-- - all models -->
            </div>
        </td>
        <td class="border-b px-2 sm:px-4 py-2">
            <span class="badge badge-success text-xs sm:text-sm font-semibold rounded" class2="text-base">
                In Stock
            </span>
        </td>
        <td class="border-b px-2 sm:px-4 py-2">
            <div class="font-semibold text-gray-800 text-base" class2="sm:text-xl">
                <span class="text-gray-700 whitespace-no-wrap" class2="text-gray-600">
                    $ $ $
                    <!-- &ndash; -->
                </span>
            </div>
        </td>
        <td class="border-b px-2 sm:px-4 py-2 hidden sm:table-cell">
            <!-- <span class="text-sm text-gray-700">
                {{ dateTime2() }}
            </span> -->
            <span class="text-gray-600 text-xs">
                &ndash;
            </span>
        </td>
        <td class="border-b px-2 sm:px-4 py-2 hidden sm:table-cell text-center">
            <a @click.prevent="openSearch" :href="searchUrl" class="btn btn-primary btn-xs border-2 rounded-full font-semibold" class2="btn-secondary">
                <span>
                    <i class="fad fa-shopping-cart fa-lg mr-1"></i>
                    Buy Now
                </span>
                <!-- <span>
                    <i class="far fa-external-link-square fa-lg mr-1"></i>
                    View Item
                </span> -->
            </a>
        </td>
    </tr>
</template>

<script>
import StoreMixin from '../../mixins/store';
import EbayMixin from '../../mixins/ebay';

export default {
    mixins: [
        StoreMixin,
        EbayMixin
    ],

    props: ['product'],

    data: () => ({
        loading: false,
        store: null
    }),

    created() {
        this.fetchStore('ebay');
    },

    mounted() {},

    computed: {
        searchQuery() {
            return this.product.name;
        }
    },

    methods: {}
}
</script>

<style lang="scss" scoped>
</style>
